import { Icons, SingleCombobox } from '@commenda/kakashi';
import { SingleSelectFilterConfig } from '../types';

interface SingleSelectFilterProps {
  config: SingleSelectFilterConfig;
  value?: string;
  onChange: (value: string) => void;
  disabled?: boolean;
}

export const SingleSelectFilter = ({
  config,
  value,
  onChange,
  disabled = false,
}: SingleSelectFilterProps) => {
  return (
    <SingleCombobox
      options={config.options}
      value={value || ''}
      setValue={onChange}
      placeholder={config.placeholder || config.label}
      hideSearch={(config.options || []).length < 10}
      _optionsClassName="min-w-[200px]"
      _className="h-10"
      useRenderTriggerForPlaceholder
      canClearSelection={false}
      disabled={disabled}
      renderOption={({ option, isSelected }) => (
        <div className="flex items-center justify-between w-48">
          <span className="txt-medium-regular  text-button-secondary-fg truncate">
            {option.label}
          </span>
          <div className="w-4 shrink-0 ml-2">
            {isSelected && <Icons.Check className="size-4" />}
          </div>
        </div>
      )}
      renderTrigger={() => (
        <span className="txt-small-medium !text-button-secondary-fg truncate">
          {config.label || config.placeholder}
        </span>
      )}
    />
  );
};
